import { makeAutoObservable } from 'mobx'
import { EnumDropdownItemVariant } from 'shared/ui'
import type { IResponseTag } from 'entities/Tags'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import type { IResponseWebsiteChatWidgetSettings } from 'entities/Settings/api/types'
import { SendFromStore } from 'widgets/SendFrom'
import { TagsDropdownControlStore } from 'widgets/TagsDropdown/store/tagsDropdownControlStore'

export class ConversationsBlockStore {
  sendFromStore: SendFromStore
  tagsControlStore = new TagsDropdownControlStore()

  constructor(private _entities: IEntitiesStore) {
    this.sendFromStore = new SendFromStore(this._entities, {
      excludeDeprioritizedNumbers: true,
      getDropdownItemsOptions: {
        showOnlyVerifiedToolFree: true,
        hideChildren: true,
        getInboxDropdownItemProps: () => ({
          variant: EnumDropdownItemVariant.CheckedRight,
          noRenderEmptyActiveValue: true,
        }),
      },
    })

    makeAutoObservable(this)
  }

  syncFromApi = (settings: IResponseWebsiteChatWidgetSettings) => {
    const team_id = settings.team_id
    const tagsFromApi = settings.tags ?? []

    if (team_id) {
      this.sendFromStore.setSendFrom({
        type: 'from_number',
        options: { team_id },
      })
    }

    if (tagsFromApi.length > 0) {
      const tagsResponse: IResponseTag[] = tagsFromApi.map((t) => ({
        id: t.id,
        name: t.name,
        label: t.name,
      }))
      this.tagsControlStore.init(tagsResponse)
    } else {
      this.tagsControlStore.reset()
    }
  }

  get teamId(): number | undefined {
    return this.sendFromStore.paramsSendFrom?.options?.team_id
  }
}
